import { dataLayerConfig } from '@aspendental/shared-components-web';
import { useAppStore } from '@src/store';

export const getSchedulerType = (): 'on page' | 'bau' => {
	if (typeof window === 'undefined') return 'bau';
	return new URLSearchParams(window.location.search).get('src') === 'ops' ? 'on page' : 'bau';
};

export const dataLayer = (params: Record<string, unknown>) => {
	const { userStateCodeForAnalytics } = useAppStore.getState();
	dataLayerConfig({
		event: 'appointment_step',
		scheduler_type: getSchedulerType(),
		...params,
		...(userStateCodeForAnalytics && { state: userStateCodeForAnalytics }),
	});
};
